module.exports = __webpack_public_path__ + "img/metroid.a76febec.svg";